import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};
export const fetchProcessorSSDMaxSequqncialWrite = createAsyncThunk(
  "ssd_max_sequential/fetchProcessorSSDMaxSequqncialWrite",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

     
      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              // For date filters
              if (
                typeof filterValue === "object" &&
                (filterValue.from_date || filterValue.to_date)
              ) {
                if (filterField === "created_at") {
                  if (filterValue.from_date) {
                    params.append(
                      "created_at_date_from",
                      String(filterValue.from_date)
                    );
                  }
                  if (filterValue.to_date) {
                    params.append(
                      "created_at_date_to",
                      String(filterValue.to_date)
                    );
                  }
                }

                if (filterField === "updated_at") {
                  if (filterValue.from_date) {
                    params.append(
                      "updated_at_date_from",
                      String(filterValue.from_date)
                    );
                  }
                  if (filterValue.to_date) {
                    params.append(
                      "updated_at_date_to",
                      String(filterValue.to_date)
                    );
                  }
                }
              } else {
                // For normal filters (string/number)
                params.append(filterField, String(filterValue));
              }
            }
          }
        );
      }

      const response: any = await Axios.get(`api/attributes/ssd-interface/list/?${params.toString()}`);
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchPackages error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch category");
    }
  }
);
export const fetchProcessorSSDMaxSequentialWriteById = createAsyncThunk(
  "ssd_max_sequential/fetchProcessorSSDMaxSequentialWriteById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`api/attributes/ssd-interface/${id}/`);
      return response.data.data; // ensure this is the object
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SSD Capacity by ID"
      );
    }
  }
);



export const fetchProcessorSSDMaxSequencialWriteByDropDown = createAsyncThunk(
  "ssd_max_sequential/fetchProcessorSSDMaxSequencialWriteByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/category/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Category list"
      );
    }
  }
);

export const updateProcessorSSDMaxSequencialWrite = createAsyncThunk(
  "ssd_max_sequential/updateProcessorSSDMaxSequencialWrite",
  async ({ id, ssd_interface_name  }: { id: string; ssd_interface_name : string }, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `api/attributes/ssd-interface/edit/${id}/`,
        { ssd_interface_name  } // ← backend expects ram_speed_name
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update RAM speed");
    }
  }
);




export const updateStatusInProcessorSSDMaxSequqnecialWrite = createAsyncThunk(
  "ssd_max_sequential/updateStatusInProcessorSSDMaxSequqnecialWrite",
  async (categoryData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: categoryData.is_active };
      const response: any = await Axios.patch(
        `api/ssd-interface/${categoryData.id}/update/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in category"
      );
    }
  }
);

export const addProcessorRamSSDMaxSequencialWrite= createAsyncThunk(
  "ssd_max_sequential/addProcessorRamSSDMaxSequencialWrite",
  async (data: { ssd_interface_name: string }, { rejectWithValue }) => {
    try {
      const payload = {
        ssd_interface_name: data.ssd_interface_name.trim(),
      };

      const response: any = await Axios.post(
        "/api/attributes/ssd-interface/create/",
        payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to add processor RAM speed" }
      );
    }
  }
);


export const deleteGp = createAsyncThunk(
  "category/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`/category/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const exportProcessorCorsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/category/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "category.csv",
  };
};
